import "@/styles/headerStyle.less";
import logo from "@/assets/images/Microsoft Ads Logo.svg";

const Header = () => {
  return (
    <header aria-label="Microsoft logo" className="Component-header-container">
      <div className="Component-container" tabIndex={0}>
        <div className="Component-item">
          <div className="Component-logoContainer">
            <img className='logo' src={logo} alt="Microsoft Ads logo" />
          </div>
        </div>

      </div>
    </header>
  );
};

export default Header;
